import { Plus, Trash2 } from "lucide-react";

const input = "bg-slate-800 border border-slate-700 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:border-orange-500";

export const AddonEditor = ({ addons, onChange, currency }) => {
  const set = (idx, patch) => onChange(addons.map((a, i) => (i === idx ? { ...a, ...patch } : a)));
  return (
    <div data-testid="addon-editor">
      <label className="text-xs font-medium uppercase tracking-wider text-slate-400">Add-ons (optional extras)</label>
      <div className="space-y-2 mt-2">
        {addons.map((a, idx) => (
          <div key={a.id || `new-${idx}`} className="flex gap-2">
            <input data-testid={`addon-name-input-${idx}`} required placeholder="e.g. Extra egg" value={a.name} onChange={(e) => set(idx, { name: e.target.value })} className={`${input} flex-1 min-w-0`} />
            <input data-testid={`addon-price-input-${idx}`} required type="number" min="0" step="0.01" placeholder={currency || "$"} value={a.price} onChange={(e) => set(idx, { price: e.target.value })} className={`${input} w-24`} />
            <button type="button" data-testid={`addon-remove-${idx}`} onClick={() => onChange(addons.filter((_, i) => i !== idx))} className="px-3 rounded-xl bg-red-950/50 text-red-400 hover:bg-red-900/60 transition-colors">
              <Trash2 className="h-3.5 w-3.5" />
            </button>
          </div>
        ))}
      </div>
      <button type="button" data-testid="add-addon-button" onClick={() => onChange([...addons, { name: "", price: "", available: true }])} className="mt-2 inline-flex items-center gap-1.5 text-sm text-orange-400 hover:text-orange-300 transition-colors">
        <Plus className="h-4 w-4" /> Add an extra
      </button>
    </div>
  );
};
